import {
  Button,
  Divider,
  Form,
  Input,
  message,
  Popconfirm,
  Select,
} from "antd";
import { useEffect, useState } from "react";
import { editArticleMainInfo, getArticleByID } from "../action";
import { ICategory } from "../../../types/Category";
import { getCategories } from "../../Categories/action";
import { PiPlus } from "react-icons/pi";
import { useParams } from "react-router-dom";
import { GiArtificialHive } from "react-icons/gi";

type Props = {
  onMainInfoEdit?: () => void;
};

interface FormData {
  title: string;
  category: string;
  author: string;
  source_name: string;
  source_link: string;
}
const EditMainInfo = (props: Props) => {
  const { onMainInfoEdit } = props;
  const [form] = Form.useForm<FormData>();
  const [categories, setCategories] = useState<ICategory[]>([]);
  const [loading, setIsLoading] = useState<boolean>(false);
  const { id } = useParams();

  const fetchData = async () => {
    if (id) {
      const result = await getArticleByID(id);
      if (result) {
        form.setFieldsValue({
          title: result.MainInfo.Title,
          category: result.MainInfo.Category.id,
          author: result.MainInfo.Author,
          source_name: result.MainInfo.Source.Name,
          source_link: result.MainInfo.Source.Link,
        });
      }
    }
  };
  const fetchCategories = async () => {
    const result = await getCategories();
    if (result) {
      setCategories(result);
    }
  };
  const onSubmit = async (values: FormData) => {
    setIsLoading(true);
    try {
      const result = await editArticleMainInfo(
        id!,
        values.title,
        values.category,
        values.author,
        values.source_name,
        values.source_link
      );
      if (result) {
        message.success("Article updated successfully");
        onMainInfoEdit?.();
      }
    } catch (err) {
      message.error("Failed to update article, please try again");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [id]);

  useEffect(() => {
    fetchCategories();
  }, []);
  return (
    <Form layout="vertical" form={form} onFinish={onSubmit}>
      <Form.Item
        label="Title"
        required
        rules={[{ required: true, message: "Please enter article title" }]}
      >
        <Input.Group compact>
          <Form.Item name="title" noStyle>
            <Input
              placeholder="Enter article title"
              style={{ width: "calc(100% - 34px)" }}
            />
          </Form.Item>
          <Button
            title="Optimize by AI"
            icon={<GiArtificialHive className="animate-pulse" />}
          />
        </Input.Group>
      </Form.Item>

      <Form.Item
        name="category"
        label="Category"
        rules={[{ required: true, message: "Please select category" }]}
      >
        <Select
          placeholder="Select category"
          options={categories.map((item) => ({
            label: item.MainInfo.Title,
            value: item.id,
          }))}
        />
      </Form.Item>
      <Divider />
      <Form.Item name="author" label="Author">
        <Input placeholder="Enter author" />
      </Form.Item>
      <div className="grid grid-cols-2 gap-4">
        <Form.Item name="source_name" label="Source Name">
          <Input placeholder="Enter source name" />
        </Form.Item>
        <Form.Item name="source_link" label="Source Link">
          <Input placeholder="Enter source link" />
        </Form.Item>
      </div>
      <Popconfirm
        title="Edit Article"
        description="Are you sure you want to edit this article?"
        onConfirm={() => form.submit()}
        okText="Yes"
        cancelText="No"
      >
        <Button type="primary" icon={<PiPlus />} loading={loading}>
          Edit Article
        </Button>
      </Popconfirm>
    </Form>
  );
};

export default EditMainInfo;
